import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { drawLabel } from './textUtils';
import { applySimStatusStyle } from './simStatus';
import { getThemeStyle } from '../theme';

class InputDataView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height } = model;
    const style = model.getNodeStyle();
    const label = model.properties?.name || model.text?.value || '';
    const r = height / 2;
    const textFill = (model.graphModel?.__epxDmnTheme?.text?.fill) || '#212121';

    return h('g', {}, [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: r,
        ry: r,
        ...style,
      }),
      drawLabel(h, label, x, y, width - r * 1.5, { fill: textFill }),
    ]);
  }

  getText() { return ''; }
}

class InputDataModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 125;
    this.height = 45;
    this.text = { ...this.text, editable: true, draggable: false, value: this.text?.value || '' };
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'inputData');
    style.stroke = t.stroke || '#13c2c2';
    style.strokeWidth = t.strokeWidth || 2;
    style.fill = t.fill || '#e6fffb';
    return applySimStatusStyle(style, this.properties);
  }

  getDefaultAnchor() {
    const { x, y, width, height } = this;
    const r = height / 2;
    return [
      { x: x - width / 2 + r, y: y - height / 2, id: `${this.id}_top` },
      { x: x + width / 2 - r, y: y - height / 2, id: `${this.id}_topR` },
      { x: x + width / 2, y, id: `${this.id}_right` },
      { x: x + width / 2 - r, y: y + height / 2, id: `${this.id}_bottomR` },
      { x: x - width / 2 + r, y: y + height / 2, id: `${this.id}_bottom` },
      { x: x - width / 2, y, id: `${this.id}_left` },
    ];
  }
}

export const InputData = {
  type: 'dmn:InputData',
  view: InputDataView,
  model: InputDataModel,
};
